import { Config, driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useAppSelector } from '../store';
import { useState } from 'react';

const defaultConfig: Config = {
  disableActiveInteraction: true,
  allowClose: true,
  showProgress: true,
};

/**
 * Custom hook for managing driver.js and related state
 * @returns {Object} An object containing driver instance and guide state
 */
const useDriver = () => {
  // Extract value and user from the guide state using useAppSelector
  const { value, user } = useAppSelector((state) => state.guide);
  const [onGuide, setOnGuide] = useState(false);

  // Return an object with driver instance and guide state
  return { driver, value, user, onGuide, setOnGuide, defaultConfig };
};

export default useDriver;
